import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import cn from 'classnames';
import { Tooltip } from 'react-tooltip';

import { MenuItems } from '../../types/MenuItems';
import { MenuPageWrapper } from '../../components/MenuPageWrapper/MenuPageWrapper';
import logo from '../../assets/images/logo-black.webp';
import axios from '../../api/axios-sixtix';
import { getTranslation } from '../../constants/translations';
import { isValidEmail as emailValidator } from '../../helpers/emailValidator';
import { Icons } from '../../components/Icons/Icons';

import './TogetherSale.scss';

const INITIAL_USER_DATA = {
  contact_name: '',
  contact_mail: '',
  mail_content: '',
};

const SALE_ID = '[25%]: ';

export const TogetherSale = () => {
  const style = window.getComputedStyle(document.body as HTMLElement);
  const [userData, setUserData] = useState(INITIAL_USER_DATA);
  const [isSubmit, setSubmit] = useState(false);

  const t = getTranslation();

  const handleChangeUserInfo = (name: string, value: string) => {
    setSubmit(false);

    setUserData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const { contact_name, contact_mail, mail_content } = userData;

    setSubmit(true);

    if (
      !userData.contact_mail ||
      !userData.contact_name ||
      !userData.mail_content
    ) {
      toast.error(t.COMMON.formErrors['empty fields']);

      return;
    }

    if (!emailValidator(userData.contact_mail)) {
      return;
    }

    const formData = new FormData();

    formData.append('contact_name', contact_name);
    formData.append('contact_mail', contact_mail);
    formData.append('mail_content', SALE_ID + mail_content);

    const config = {
      headers: { 'content-type': 'multipart/form-data' },
    };

    try {
      const { data } = await axios.post(
        '/Frontpage_controller/contactForm',
        formData,
        config,
      );

      if (data.success) {
        setUserData(INITIAL_USER_DATA);
        toast.success('E-mail succesvol verzonden');
      } else {
        toast.error('Er is iets misgegaan. Probeer het later opnieuw.');
      }
    } catch (error) {
      console.log(error);
      toast.error('Er is iets misgegaan. Probeer het later opnieuw.');
    } finally {
      setSubmit(false);
    }
  };

  useEffect(() => {
    setUserData(INITIAL_USER_DATA);
    setSubmit(false);
  }, [window.location.hash]);

  return (
    <MenuPageWrapper
      id={MenuItems.TOGETHER_SALE}
      color={style.getPropertyValue('--yellow')}
    >
      <div className="menu-page-wrapper__content">
        <h3 className="menu-page-wrapper__title">
          {t.TOGETHER_SALE.mainTitle}
        </h3>

        <div className="menu-page-wrapper__text">
          <p
            dangerouslySetInnerHTML={{ __html: t.TOGETHER_SALE.contentHTML }}
          ></p>
        </div>
      </div>
      <>
        <img className="menu-page-wrapper__logo" src={logo} alt="SixTix" />
        <form className="menu-page-wrapper__form" onSubmit={handleSubmit}>
          <label
            className={cn('label', {
              'label--error': !userData.contact_name && isSubmit,
            })}
          >
            <input
              type="text"
              className="_blockLogoHover"
              placeholder={t.TOGETHER.name}
              name="contact_name"
              value={userData.contact_name}
              onChange={({ target }) =>
                handleChangeUserInfo(target.name, target.value)
              }
            />
          </label>
          <label
            className={cn('label', {
              'label--error': !userData.contact_mail && isSubmit,
            })}
          >
            <input
              type="email"
              className="_blockLogoHover"
              placeholder={t.TOGETHER.email}
              name="contact_mail"
              value={userData.contact_mail}
              onChange={({ target }) =>
                handleChangeUserInfo(target.name, target.value)
              }
            />

            {!emailValidator(userData.contact_mail) &&
              !!userData.contact_mail && (
                <Icons
                  name="alert"
                  customClassName="label__icon"
                  data-tooltip-id="email-validator"
                />
              )}

            <Tooltip
              id="email-validator"
              className="custom-tooltip"
              openOnClick={true}
            >
              <p>{t.COMMON.formErrors['Email is not valid']}</p>
            </Tooltip>
          </label>
          <label
            className={cn('label', {
              'label--error': !userData.mail_content && isSubmit,
            })}
          >
            <textarea
              placeholder={t.TOGETHER.info}
              className="_blockLogoHover"
              name="mail_content"
              value={userData.mail_content}
              onChange={({ target }) =>
                handleChangeUserInfo(target.name, target.value)
              }
            ></textarea>
          </label>
          <button
            className="together-sale__submit menu-submit _blockLogoHover"
            type="submit"
          >
            {t.TOGETHER_SALE.submit}
          </button>
        </form>
      </>
    </MenuPageWrapper>
  );
};
